export default {"src":"/_next/static/image/src/images/Homepage/box-scoops.dac84421b08ed198308bab5c0f867b16.svg","height":54,"width":149};